<!--
 * @Author: DQL
 * @Date: 2020-03-18 10:31:17
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 11:43:56
 * @Description: 机构管理--查看机构信息
 -->
<template>
  <div class="l-page l-page--detail">
    <!-- 页面头部 Start -->
    <div class="l-page__header c-page__header">
      <!-- 页面标题 -->
      <h2 class="c-page__header-title">
        企业信息维护
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div class="c-page__header-btns">
        <k-button
          v-show="pageStatus!=='editDept'"
          btn-text="编辑"
          :auth-type="true"
          type="success"
          icon="kestrel-icon ki-edit"
          @click="handleSwitchPageStatus('editDept')"
        />
        <k-button
          v-show="pageStatus==='editDept'"
          btn-text="保存"
          :auth-type="true"
          type="primary"
          icon="kestrel-icon ki-save"
          @click="handleSave()"
        />
        <k-button
          v-show="pageStatus==='editDept'"
          btn-text="关闭"
          :auth-type="false"
          icon="kestrel-icon ki-close"
          @click="handleSwitchPageStatus('viewDept')"
        />
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 页面主内容：详情 Start -->
    <div class="l-page__body l-page--detail__body">
      <hm-page-card class="c-card--detail">
        <components
          :is="pageStatus"
          ref="editDept"
          :is-loading.sync="loading"
          :dept-code="deptCode"
          @switch="handleSwitchPageStatus"
        />
      </hm-page-card>
    </div>
    <!-- 页面主内容：详情 End -->
  </div>
</template>

<script>
export default {
  name: 'XfAttrDeptManage',
  components: {
    editDept: () => import('./editDept'),
    viewDept: () => import('./viewDept')
  },

  data () {
    return {
      loading: false, // 页面loading状态

      deptCode: null,

      pageStatus: 'viewDept' // 页面状态：edit（编辑），view（查看）

    };
  },
  methods: {
    /**
     * @description: 切换页面状态
     * @param {*}
     * @return {*}
     */
    handleSwitchPageStatus (_status) {
      this.pageStatus = _status;
    },
    handleSave () {
      this.$refs.editDept.handleSave();
    }
  },
  created () {
    this.loading = true;
    const currentUser = this.$HMStoreService.getUserinfo();
    this.deptCode = currentUser.capacity.deptCode;
  }
};
</script>

<style>
</style>
